import { render } from "./homefoot.vue?vue&type=template&id=ad72c0ca"
import script from "./homefoot.vue?vue&type=script&lang=js"
export * from "./homefoot.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__